module.exports = __webpack_public_path__ + "img/2.99cf6d8d.svg";